export const DEFAULT_PAGE = 1
export const MIN_PAGE = 1
export const TABLE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100]
export const DEFAULT_PAGE_SIZE = TABLE_PAGE_SIZE_OPTIONS[0]
export const POLLING_INTERVAL_IN_MS = 60000
